import { CustomFieldDefinition, CustomFieldDefinitionOptions } from '../../../types';
import { callExternalApi } from '../../callExternalApi';

export type CreateCustomFieldDefinitionRequest = {
  name: string;
  entity_type: string;
  field_type: string;
  is_editable?: boolean;
  options?: CustomFieldDefinitionOptions;
};

export type UpdateCustomFieldDefinitionRequest = {
  name?: string;
  is_archived?: boolean;
  is_editable?: boolean;
  options?: CustomFieldDefinitionOptions;
};

export type ChangeCustomFieldTypeRequest = {
  new_field_type: string;
  new_options?: CustomFieldDefinitionOptions;
  force?: boolean;
};

export type IncompatibleCustomFieldValue = {
  entity_id: string;
  entity_type: string;
  value: string;
};

export type ChangeCustomFieldTypeError = {
  error: string;
  message: string;
  incompatible_values?: IncompatibleCustomFieldValue[];
};

export const fetchCustomFieldDefinitionsApi = async (
  accountId: string,
  parentAccountId?: string,
  entityType?: string
) => {
  const params = new URLSearchParams({ account_id: accountId });
  if (parentAccountId) params.append('parent_account_id', parentAccountId);
  if (entityType) params.append('entity_type', entityType);
  return await callExternalApi<CustomFieldDefinition[]>({
    url: `api/custom_field_definitions?${params.toString()}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const createCustomFieldDefinitionApi = async (
  accountId: string,
  requestBody: CreateCustomFieldDefinitionRequest
) => {
  return await callExternalApi<CustomFieldDefinition>({
    url: `api/custom_field_definitions?account_id=${accountId}`,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data: { custom_field_definition: requestBody }
  });
};

export const updateCustomFieldDefinitionApi = async (id: string, requestBody: UpdateCustomFieldDefinitionRequest) => {
  return await callExternalApi<CustomFieldDefinition>({
    url: `api/custom_field_definitions/${id}`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data: { custom_field_definition: requestBody }
  });
};

export const changeCustomFieldTypeApi = async (id: string, requestBody: ChangeCustomFieldTypeRequest) => {
  return await callExternalApi<CustomFieldDefinition>({
    url: `api/custom_field_definitions/${id}/change_field_type`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data: requestBody
  });
};
